export const mutations = {
    SET_USAGE_PROFILES(state, usageProfiles) {
        state.usageProfiles = usageProfiles;
    }
};
